export default __webpack_public_path__ + "static/media/notify.a922ff06.svg";